import { getView, requireAuth } from '@/lib/utils';
import { Left } from 'Models/Menu/menus';
import {
  UserDetailsPage,
  UserFilesPage,
  UserEditPage,
} from '@/data/appInformationItems';

export default {
  path: '/users/:_key',
  name: 'user',
  component: getView('pages/PageUser'),
  redirect: { name: 'user-details' },
  meta: {
    roles: ['operator'],
  },
  children: [
    {
      path: 'details',
      name: 'user-details',
      component: getView('users/TabDetails'),
      beforeEnter: requireAuth,
      meta: {
        crumbs: 'Users > Details',
        leftMenu: Left.UserDetails,
        information: UserDetailsPage,
        showBottomMenu: true,
      },
    },
    {
      path: 'files',
      name: 'user-files',
      component: getView('users/TabFiles'),
      beforeEnter: requireAuth,
      meta: {
        crumbs: 'Users > Files',
        leftMenu: Left.UserFiles,
        information: UserFilesPage,
        showBottomMenu: true,
      },
    },
    {
      path: 'edit',
      name: 'userEdit',
      component: getView('pages/PageUserEdit'),
      beforeEnter: requireAuth,
      meta: {
        crumbs: 'Users > Edit',
        leftMenu: Left.UsersList,
        information: UserEditPage,
        showBottomMenu: true,
      },
    },
  ],
};
